import { gql } from '@apollo/client';

export const QA_RESULT_FRAGMENT = gql`
  fragment QAResultFragment on QAResult {
    detectedSDKFunctionality
    SDKImplemented
    adScenario
    SDKInfo {
      sdkType
      version
      wrapper {
        engine
        sdkVersion
      }
    }
    initialLoadSizeBytes
  }
`;
